// extracted by mini-css-extract-plugin
module.exports = {"bio":"SuccesResetPassword_bio__3DDpn ForgotPasswordForm_bio__3V22r"};